<template>
<div class="m-1 mb-2" :style="skin.search.body" style="overflow:hidden">
    <div class="p-2" :style="skin.search.header">{{ translate("live_broadcast") }}</div>
    <div class="p-2">
        <select v-model="selectedEventId" @change="updateEvent"
            :style="skin.carrousel_event.liga_text"
            style="background-color: transparent;font-size: 13px; height: 36px; padding: 0 4px; border: none; appearance: none; outline: none; cursor: pointer;">
            <option value="" disabled>Live Matches Availables</option>
            <option v-for="event in eventsTv" :key="event.id" :value="event.id">
            <span v-if="event.id == selectedEventId">
                +
            </span>
            {{ event.sportName }} - {{ event.name }}
            </option>
        </select>
    </div>
    <div class="responsive-container">
      <iframe v-if="user && user.token !==''" allowfullscreen="true" scrolling="no" :src="currentIframe" allow="encrypted-media" frameborder="0" referrerpolicy="no-referrer" style="overflow: hidden;"></iframe>
      <iframe v-else :srcdoc="htmlStreamingNotAllowed()" frameborder="0"></iframe>
    </div>
</div>
</template>

<script>
const axios = require("axios");
export default {
    name: "main_streaming",
    components: {
        
    },
    props: ["skin", "language", "translation"],
    data() {
        return {
            data: [],
            selectedEventId: null,
            currentIframe: "",
            eventsTv: [],
        };
    },
    methods:{
        htmlStreamingNotAllowed(){
            return  `<div>
                <div style="color: #ffffff;text-align: center; padding-top: 20px; font-family: Arial, Helvetica, sans-serif;">
                <svg data-v-94e88d1a="" width="65" height="64" viewBox="0 0 65 64" fill="none" xmlns="http://www.w3.org/2000/svg" class="StreamingPlaceholderstyled__StreamingPlaceholderIcon-sc-h0cbp6-1 btUCon"><g data-v-94e88d1a="" clip-path="url(#clip0_79700_40233)"><path data-v-94e88d1a="" d="M21.833 56H43.1663M25.5095 34.9902C24.7666 34.2473 24.1773 33.3654 23.7753 32.3948C23.3733 31.4242 23.1663 30.3839 23.1663 29.3333C23.1663 28.2828 23.3733 27.2425 23.7753 26.2719C24.1773 25.3013 24.7666 24.4193 25.5095 23.6765M39.4899 23.6765C40.2327 24.4193 40.822 25.3013 41.224 26.2719C41.6261 27.2425 41.833 28.2828 41.833 29.3333C41.833 30.3839 41.6261 31.4242 41.224 32.3948C40.822 33.3654 40.2327 34.2473 39.4899 34.9902M21.7383 38.7614C20.5001 37.5233 19.518 36.0535 18.8479 34.4358C18.1779 32.8181 17.833 31.0843 17.833 29.3333C17.833 27.5824 18.1779 25.8486 18.8479 24.2309C19.518 22.6132 20.5001 21.1434 21.7383 19.9052M43.2611 19.9052C44.4992 21.1434 45.4813 22.6132 46.1514 24.2309C46.8215 25.8486 47.1663 27.5824 47.1663 29.3333C47.1663 31.0843 46.8215 32.8181 46.1514 34.4358C45.4813 36.0535 44.4992 37.5233 43.2611 38.7614M7.16634 50.6667H57.833C60.7785 50.6667 63.1663 48.2789 63.1663 45.3333V13.3333C63.1663 10.3878 60.7785 8 57.833 8H7.16634C4.22082 8 1.83301 10.3878 1.83301 13.3333V45.3333C1.83301 48.2789 4.22082 50.6667 7.16634 50.6667ZM35.1663 29.3333C35.1663 30.8061 33.9724 32 32.4997 32C31.0269 32 29.833 30.8061 29.833 29.3333C29.833 27.8606 31.0269 26.6667 32.4997 26.6667C33.9724 26.6667 35.1663 27.8606 35.1663 29.3333Z" stroke="#ffffff8a" stroke-opacity="0.54" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></g><defs data-v-94e88d1a=""><clipPath data-v-94e88d1a="" id="clip0_79700_40233"><rect data-v-94e88d1a="" width="64" height="64" fill="white" transform="translate(0.5)"></rect></clipPath></defs></svg>
                <br><span style="color: rgba(255, 255, 255, 0.54);font-size: 12px;">${this.translate('streaming_not_allowed')}</span>
                </div>
                </div>`;
        },
        updateEvent() {
            const selected = this.eventsTv.find((event) => event.id === this.selectedEventId);
            if (selected) {
                this.currentIframe = selected.streamUrl[0];
            } else {
                this.currentIframe = "";
            }
        },
        async fetchEvents() {
            try {
                const response = await axios.get('https://sports-data.betalogic.io/v1/data/get_main_data');
                const parentDomains = [
                    "sports.jcasino.live",
                ];
                if(this.user.domain) {
                    parentDomains.push(this.user.domain.split('https://')[1]);
                } else {
                    // get the parend domain from the current URL
                    const currentUrl = window.location.href;
                    const url = new URL(currentUrl);
                    const parentDomain = url.hostname;
                }
                this.eventsTv = response.data.data
                for (let i = 0; i < this.eventsTv.length; i++) {
                if (this.eventsTv[i].streamUrl.length > 0 && this.eventsTv[i].streamProvider === 7) {
                    this.eventsTv[i].streamUrl[0] = this.eventsTv[i].streamUrl[0] + (parentDomains.length > 0 ? '&parent=' +parentDomains.join('&parent=') : '');
                }
                }

                // Seleccionar el primer evento si hay eventos disponibles
                if (this.eventsTv.length >= 1) {
                this.selectedEventId = this.eventsTv[0].id;
                this.currentIframe = this.eventsTv[0].streamUrl[0];
                }
            } catch (e) {
                console.error('Error fetching events:', e);
            }
        },
        startAutoRefresh() {
            // Actualiza la lista de eventos cada 5 minutos (300,000 ms)
            this.refreshInterval = setInterval(() => {
                console.log('Refreshing events...');
                this.fetchEvents();
            }, 300000);
        },
        stopAutoRefresh() {
            // Limpia el intervalo al desmontar el componente
            if (this.refreshInterval) {
                clearInterval(this.refreshInterval);
                this.refreshInterval = null;
            }
        },
        translate(text){
            if (this.$props.translation[text]) {
                return this.$props.translation[text][this.$props.language];
            }
            return text;
        },
        sizeControl(){
            this.screen_width=window.innerWidth;
        },
    },
    computed:{
        user() {
            return this.$store.getters['getUserData'];
        },
    },
    watch:{
    },
    created() {
        this.sizeControl();
    },
    mounted(){
        window.addEventListener('resize', ()=>{this.sizeControl();});
        this.fetchEvents();
    this.startAutoRefresh();
    },
    beforeDestroy() {
        this.stopAutoRefresh(); // Detiene el intervalo al salir del componente
    },
}
</script>

<style scoped>
.responsive-container {
    position: relative;
    width: 106%; /* Ancho completo */
    padding-top: 61%; /* Mantiene la relación 2:1 (850 / 1700 * 100) */
    overflow: hidden; /* Para evitar desbordamiento */
  }

  .responsive-container iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover; /* Ajusta la imagen para llenar el espacio */
  }
</style>